import React from 'react';

const data = [
  {
    sup: '1',
    note:
      'https://www.nokia.com/networks/technologies/ava-cognitive-services-platform/#features-and-benefits',
    link:
      'https://www.nokia.com/networks/technologies/ava-cognitive-services-platform/#features-and-benefits'
  },
  {
    sup: '2',
    note: 'See [5] at www.intel.com/3gen-xeon-config. Results may vary.',
    link:
      'https://edc.intel.com/content/www/us/en/products/performance/benchmarks/3rd-generation-intel-xeon-scalable-processors/'
  },
  {
    sup: '3',
    note: 'See [9] at www.intel.com/3gen-xeon-config. Results may vary.',
    link:
      'https://edc.intel.com/content/www/us/en/products/performance/benchmarks/3rd-generation-intel-xeon-scalable-processors/'
  }
];

const Footnotes = () => {
  return (
    <div className="footnotes">
      <div className="footnotes__container">
        <div className="footnotes__row">
          <div className="superscript">
            <sup>1</sup>
          </div>
          <div className="footnote">
            <p>
              <a
                href="https://www.nokia.com/networks/technologies/ava-cognitive-services-platform/#features-and-benefits"
                target="_blank"
                rel="sponsored"
              >
                https://www.nokia.com/networks/technologies/ava-cognitive-services-platform/#features-and-benefits
              </a>
            </p>
          </div>
        </div>
        <div className="footnotes__row">
          <div className="superscript">
            <sup>2</sup>
          </div>
          <div className="footnote">
            <p>
              See “Azure global infrastructure” at{' '}
              <a
                href="https://azure.microsoft.com/global-infrastructure/"
                target="_blank"
                rel="sponsored"
              >
                https://azure.microsoft.com/global-infrastructure/
              </a>
            </p>
          </div>
        </div>
        <div className="footnotes__row">
          <div className="superscript">
            <sup>3</sup>
          </div>
          <div className="footnote">
            <p>
              See [9] at{' '}
              <a
                href="https://edc.intel.com/content/www/us/en/products/performance/benchmarks/3rd-generation-intel-xeon-scalable-processors/"
                target="_blank"
                rel="sponsored"
              >
                www.intel.com/3gen-xeon-config
              </a>{' '}
              Results may vary.
            </p>
          </div>
        </div>
        <div className="footnotes__row">
          <div className="superscript">
            <sup>4</sup>
          </div>
          <div className="footnote">
            <p>
              See [5] at{' '}
              <a
                href="https://edc.intel.com/content/www/us/en/products/performance/benchmarks/3rd-generation-intel-xeon-scalable-processors/"
                target="_blank"
                rel="sponsored"
              >
                www.intel.com/3gen-xeon-config
              </a>{' '}
              Results may vary.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footnotes;
